import React, { PureComponent } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';

import { MODAL_RESIZE_DEBOUNCE } from 'constants/debounce-delays';
import tracking from 'tracking';
import ProductDetailsPanel from 'components/product-details-panel';
import ProductDetailsContent from 'components/product-details-content';
import BuyBox from 'components/buy-box';

const HEIGHT_OFFSET = 88;

function getProductSlug(href) {
    const nomalisedHref = href.replace(/\/$/, ''); // remove trailing slashes
    return nomalisedHref.split('/').pop();
}

class ProductDetail extends PureComponent {
    static propTypes = {
        isDesktop: PropTypes.bool.isRequired,
        viewportHeight: PropTypes.number.isRequired,
        scrollbarWidth: PropTypes.number.isRequired,
        isSticky: PropTypes.bool.isRequired,
        product: PropTypes.object,
        href: PropTypes.string,
        fetch: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        setReady: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.fetch(getProductSlug(this.props.href)).catch(() => {
            window.location.href = this.props.href;
        });

        if (this.props.product) {
            this.onProductReady(this.props.product);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.viewportHeight !== this.props.viewportHeight || nextProps.product && !this.props.product) {
            this.debouncedHeightUpdate(nextProps.viewportHeight - HEIGHT_OFFSET);
        }

        if (nextProps.product && !this.props.product) {
            this.onProductReady(nextProps.product);
        }
    }

    componentWillUnmount() {
        this.debouncedHeightUpdate.cancel();
        this.props.reset();
    }

    onProductReady(product) {
        this.props.setReady({ isReady: true });
        tracking.productDetail(product);
    }

    onProductBought = () => {
        this.props.closeModal();
    };

    debouncedHeightUpdate = debounce(function(props) {
        this.updateHeights(props);
    }, MODAL_RESIZE_DEBOUNCE);

    updateElHeight(el, newHeight) {
        if (el.style.height) {
            el.style.height = null;
        }

        if (this.props.isDesktop) {
            el.style.height = el.scrollHeight > newHeight ? `${ newHeight }px` : null;
        }
    }

    updateHeights(newHeight) {
        if (this.refs.main) {
            this.updateElHeight(this.refs.main, newHeight);
        }

        if (this.refs.sidebar) {
            this.updateElHeight(this.refs.sidebar, newHeight);
        }
    }

    render() {
        const { product, isDesktop, isSticky, scrollbarWidth } = this.props;

        return (
            <div className="modal--inner">
                <div className="modal--scroller">
                    <div className="modal--content-wrapper">
                        <div ref="main" className="grid modal--grid grid__condensed">
                            <div className="modal--container grid--container">
                                <div className="modal--content">
                                    { product && <ProductDetailsContent
                                        hasBuyBox={ false }
                                        facet="modal"
                                        mustIncludeDetailsPanel={ !isDesktop }
                                        product={ product }/> }
                                </div>
                            </div>
                        </div>
                        { product && isDesktop ?
                            <aside ref="sidebar" className="modal--sidebar"><ProductDetailsPanel product={ product }/>
                            </aside> : null }
                    </div>
                </div>
                { !isDesktop && product && <div className="modal--footer"
                    style={ { width: isSticky ? `calc(100% - ${ scrollbarWidth }px)` : null } }>
                    <BuyBox product={ product } onBought={ this.onProductBought }/>
                </div> }
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        product: 'product.item',
        href: 'modal.href',
        viewportHeight: 'viewport.height',
    }),
    reduxUtils.mapDispatchToProps({
        fetch: 'product.fetch',
        reset: 'product.reset',
        setReady: 'modal.setReady',
        closeModal: 'modal.close',
    }),
)(ProductDetail);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/modal/product-detail/index.js